import { Api } from 'lib/api.mjs';

/**
 * The ad-off watchdog: incidents (an ad switched off inside a running
 * campaign by someone who is not this dashboard), the two actions on them,
 * and the admin settings.
 */

/** Incidents, the last check, and — for an admin — the settings and diagnostics. */
export function getWatchdog({ signal } = {}) {
  return Api.get('/watchdog', { signal });
}

/** Admin only. @param {{ enabled?: boolean, intervalMin?: number, trustedNames?: string[], autoReenable?: boolean }} payload */
export function saveWatchdogSettings(payload) {
  return Api.put('/watchdog/settings', { body: payload });
}

/** Admin only: one round now, whatever the switch says. Answers when it is done. */
export function runWatchdogNow() {
  return Api.post('/watchdog/run', { body: {} });
}

/** Turn the ad back on on Meta and close the incident. Safe to call twice. */
export function turnIncidentOn({ id }) {
  return Api.post(`/watchdog/incidents/${encodeURIComponent(id)}/on`, { body: {} });
}

/** Close the incident without touching Meta. */
export function leaveIncidentOff({ id }) {
  return Api.post(`/watchdog/incidents/${encodeURIComponent(id)}/off`, { body: {} });
}

/** Every open "turned off" incident, one after another. */
export function turnAllIncidentsOn() {
  return Api.post('/watchdog/incidents/on-all', { body: {} });
}
